"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _mui = require("@ori-ui/mui");
const Snackbar = exports.Snackbar = (0, _mui.styled)(_mui.Snackbar)(({
  theme
}) => ({
  left: 15,
  right: 15,
  top: 'calc(var(--top-nav-height, 94px) + 15px)',
  [theme.breakpoints.up('sm')]: {
    left: 'auto',
    right: 30,
    top: 'calc(var(--top-nav-height, 98px) + 30px)'
  }
}));
//# sourceMappingURL=styles.js.map